var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.63 5.107H1.562c-1.05 0-1.05 1.785 0 1.785H11.63L8.866 9.96c-.735.815.385 2.057 1.154 1.242l4.094-4.58a.935.935 0 0 0 0-1.242L10.02.799c-.77-.815-1.889.427-1.154 1.28l2.764 3.028Z",
    fill: "#141975"
  })));
};
export default SvgRightArrow;